module.exports = __webpack_public_path__ + "static/media/sale-2.9b211b56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sale-2.jpg
// module id = 505
// module chunks = 33